import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ROUTE_PAYMENT_ALL_SUCCESS = 'GET_ROUTE_PAYMENT_ALL_SUCCESS';
export const GET_ROUTE_PAYMENT_ALL_LOADING = 'GET_ROUTE_PAYMENT_ALL_LOADING';
export const GET_ROUTE_PAYMENT_ALL_REJECT = 'GET_ROUTE_PAYMENT_ALL_REJECT';

//* ACTIONS ------------------------------------------------
export const getRoutePaymentAllLoading = () => ({ type: GET_ROUTE_PAYMENT_ALL_LOADING});
export const getRoutePaymentAllSuccess = (payload) => ({ type: GET_ROUTE_PAYMENT_ALL_SUCCESS, payload });
export const getRoutePaymentAllReject = (payload) => ({ type: GET_ROUTE_PAYMENT_ALL_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getRoutePaymentAllRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/TypePaymentsRoute/GetAllTypePaymentsRoute/${params.id}`, options);
};